//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { IAlarmDefinitionsEditOptions, IAlarmDefinitionsBulkEditOptions } from '../alarm-definitions-edit'
import { IAlarmDefinitionsEdit } from './interfaces/alarm-definitions-edit.interfaces'
import { IMRBaseControlDirectiveController } from '../../base'

// #region AlarmDefinitionsEditScope

export interface IAlarmDefinitionsEditScope
    extends ng.IScope {
    id: number

    alarmDefinitionsSingleEditSource: IAlarmDefinitionsEditOptions
    alarmDefinitionsBulkEditSource: IAlarmDefinitionsBulkEditOptions

    options: {
        alarmDefinitionsOptions: IAlarmDefinitionsEditOptions | IAlarmDefinitionsBulkEditOptions,
        onInitialized: (component: any) => void
    }
}

// #endregion

export class AlarmDefinitionsEditController
    extends
    IMRBaseControlDirectiveController
    implements
    IAlarmDefinitionsEdit {
    // #region Consts

    // #endregion

    // #region Members

    // #endregion

    // #region Ctor

    constructor(
        private $scope: IAlarmDefinitionsEditScope
    ) {
        super()

        this.initialize()
    }

    // #endregion

    //#region IAlarmDefinitionsEdit
    public showSingleEdit(): void {
        this.$scope.alarmDefinitionsSingleEditSource = this.getAlarmDefinitionsEditSource()
    }

    public showBulkEdit(): void {
        this.$scope.alarmDefinitionsBulkEditSource = this.getAlarmDefinitionsEditSource()
    }

    private getAlarmDefinitionsEditSource(): IAlarmDefinitionsBulkEditOptions {
        return {
            moduleName: this.$scope.options.alarmDefinitionsOptions.moduleName,
            onAlarmConfigurableSaved: this.$scope.options.alarmDefinitionsOptions.onAlarmConfigurableSaved,
            referenceType: this.$scope.options.alarmDefinitionsOptions.referenceType,
            referenceObject: this.$scope.options.alarmDefinitionsOptions.referenceObject,
            configurationReferenceObject: this.$scope.options.alarmDefinitionsOptions.configurationReferenceObject,
            gridDataSource: _.size((<IAlarmDefinitionsBulkEditOptions>this.$scope.options.alarmDefinitionsOptions).gridDataSource) > 0
                ? (<IAlarmDefinitionsBulkEditOptions>this.$scope.options.alarmDefinitionsOptions).gridDataSource.map((item: any) => angular.copy(item)) //need copy
                : null,
            sendConfiguration: this.$scope.options.alarmDefinitionsOptions.sendConfiguration,
            sendConfigurationIdActivity: this.$scope.options.alarmDefinitionsOptions.sendConfigurationIdActivity,
            getEentityRequestMethod: (<IAlarmDefinitionsBulkEditOptions>this.$scope.options.alarmDefinitionsOptions).getEentityRequestMethod,
            getColumnsMethod: (<IAlarmDefinitionsBulkEditOptions>this.$scope.options.alarmDefinitionsOptions).getColumnsMethod
        }
    }

    //#endregion

    // #region Lifecycle

    private initialize = (): void => {
        if (this.$scope.options != null && _.isFunction(this.$scope.options.onInitialized)) {
            this.$scope.options.onInitialized(this)
        }
    }
}
